// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Defines channels used to pass property settings to service.
 * Added in version 1.7.0.
 */
export enum ServicePropertyChannel {
    /**
     * Uses URI query parameter to pass property settings to service.
     */
    UriQueryParameter = 0.
}
